export default __webpack_public_path__ + "static/media/return.b2e3e8cc.svg";